import { render, staticRenderFns } from "./mapRiding.vue?vue&type=template&id=1927c8a6&scoped=true&"
import script from "./mapRiding.vue?vue&type=script&lang=js&"
export * from "./mapRiding.vue?vue&type=script&lang=js&"
import style0 from "./mapRiding.vue?vue&type=style&index=0&id=1927c8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1927c8a6",
  null
  
)

export default component.exports